import { type AxiosRequestHeaders } from 'axios'
import * as env from 'src/utils/env'
import { authManager } from 'src/api/auth'

interface CustomAxiosRequestHeaders extends AxiosRequestHeaders {
    'X-App-Name': string
    'X-Source': string
    'X-Access-Token': string
    'X-App-Version': string
}

export const getHeaders = async (): Promise<AxiosRequestHeaders> => {
    const tokens = await authManager.getTokens().catch(error => {
        console.error(error)
    })
    const xAccessToken = (tokens && tokens.accessToken) ?? ''

    return {
        'Content-Type': 'application/json',
        'X-App-Name': 'fm-dashboard',
        'X-Source': 'fm-dashboard',
        'X-Access-Token': xAccessToken,
        'X-App-Version': env.BUILD_SHORT_SHA,
    } as CustomAxiosRequestHeaders
}
